import React, { Component } from "react";
import PropTypes from "prop-types";
import { Input, Links, Image } from "components";
import { Form, H1, FlexRow } from "appStyles";
import styled from "react-emotion";

const P = styled("p")`
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 0.9375rem;
  line-height: 0.9375rem;
  display: flex;
  align-items: flex-end;
  letter-spacing: 0.4px;
  width: 30%;
`;

const AboutUsForm = ({
  updateImage,
  updateLogoImage,
  addLink, // V1 doesn't allow user to add their own link
  updateLinkIcon,
  removeLink,
  clearLink,
  updateLink,
  updateApp,
  application,
  newBusiness,
}) => {
  const {
    mainImageLink,
    logo,
    links,
    name,
    website,
    code,
    appCodeAvailable,
    oldAppCode,
  } = application;

  // console.log(application);

  const appCodeMessage = () => {
    if (!code) {
      return (
        <p
          style={{
            color: "red",
          }}
        >
          Application Code cannot be empty
        </p>
      );
    } else if (oldAppCode === code) {
      return null;
    } else if (!appCodeAvailable) {
      return (
        <p
          style={{
            color: "red",
          }}
        >
          Application Code Not Available
        </p>
      );
    } else {
      return (
        <p
          style={{
            color: "green",
          }}
        >
          Application Code Available
        </p>
      );
    }
  };

  return (
    <div>
      <Form background="white" style={{ marginBottom: "3em" }}>
        <H1
          style={{ letterSpacing: "2px", fontSize: "24px", textAlign: "left" }}
        >
          Application Name
        </H1>
        <div
          style={{
            margin: "1em 0 1em 0",
            display: "flex",
            alignItems: "center",
          }}
        >
          <FlexRow style={{ paddingTop: "20px" }} height="auto">
            <P style={{ marginRight: "35px" }}>App Name</P>
            <Input
              // field="APP NAME (Required)"
              defaultValue={name}
              onChange={updateApp("name")}
              marginBottom={"0px"}
            />
          </FlexRow>
        </div>
      </Form>

      <Form background="white" style={{ marginBottom: "3em" }}>
        <H1
          style={{ letterSpacing: "2px", fontSize: "24px", textAlign: "left" }}
        >
          Application Info
        </H1>
        <div
          style={{
            margin: "1em 0 1em 0",
            display: "flex",
            width: "427px",
            alignItems: "center",
          }}
        >
          <P>App Icon</P>

          <Image
            options={{ croppingAspectRatio: "1.0" }}
            imageUrl={logo}
            uploadImage={updateLogoImage}
            titleWidth="44px"
          />
        </div>

        <div
          style={{
            margin: "1em 0 1em 0",
            display: "flex",
            width: "427px",
            alignItems: "center",
          }}
        >
          <P>Banner Image</P>
          <Image
            options={{
              croppingAspectRatio: 1.78,
            }}
            imageUrl={mainImageLink}
            uploadImage={updateImage}
            titleWidth="44px"
          />
        </div>
        {/* {newBusiness ? (
        <FlexRow style={{ paddingTop: "20px" }}>
          <P>App Name</P>
          <Input
            field="APP NAME (Required)"
            defaultValue={name}
            onChange={updateApp("name")}
          />
        </FlexRow>
      ) : null} */}
        <div
          style={{
            margin: "1em 0 1em 0",
            display: "flex",

            alignItems: "center",
          }}
        >
          <FlexRow style={{ paddingTop: "20px" }}>
            <P style={{ marginRight: "35px" }}>Website Url</P>
            <Input
              // field="WEBSITE URL"
              defaultValue={website}
              onChange={updateApp("website")}
              marginBottom={"0px"}
            />
          </FlexRow>
        </div>
        {/* {appCodeMessage()} */}
        {/* <FlexRow>
        <Input field='Application Code' 
          defaultValue={code}
          onChange={updateApp('code')}/>
        <HintModal
          position='absolute'
          containerRight='0'
        >
          <P fontSize='0.8em'>Application Code is something that uniquely identifies your application. Your customers can find your application using it, so be sure to make it simple and short.</P>
        </HintModal>
      </FlexRow> */}
        <Links
          links={links}
          updateLinkIcon={updateLinkIcon}
          updateLink={updateLink}
          removeLink={removeLink}
          clearLink={clearLink}
          editMode={true}
        />
      </Form>
    </div>
  );
};

AboutUsForm.propTypes = {
  updateImage: PropTypes.func,
  addLink: PropTypes.func,
  removeLink: PropTypes.func,
  updateLink: PropTypes.func,
  updateLinkIcon: PropTypes.func,
  updateApp: PropTypes.func,
  updateLogoImage: PropTypes.func,
  application: PropTypes.object,
};

export default AboutUsForm;
